module.exports = __webpack_public_path__ + "static/media/2.6e1b84cc.jpeg";